<template>
  <div>
    <el-row>
      <h6 style="text-align: left">直接推荐代理商</h6>
      <div v-if="this.$store.state.CurrentUser != 'super_admin'">
        <router-link :to="{path: '/provider/details', query: {id: recommender}}">{{recommender}}</router-link>
      </div>
      <div v-else>
        <el-row>
          <el-col :span="6">
            <el-input v-model="recommender" placeholder="直接推荐代理商"></el-input>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-popconfirm
              confirm-button-text='确认'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="确认要更改当前代理商的直接推荐代理商吗？"
              @confirm="confirmUpdateRecommender"
            >
              <el-button slot="reference" type="danger"><i class="el-icon-edit"></i> 更改</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </div>
    </el-row>

    <el-row style="margin-top: 20px;">
      <h6 style="text-align: left">名下代理商</h6>
      <el-table
        :data="providerList"
        border
        style="width: 100%">
        <el-table-column
          label="#">
          <template slot-scope="scope">
            <router-link :to="{path: '/provider/details', query: {id: scope.row.id}}">{{scope.row.id}}</router-link>
          </template>
        </el-table-column>

        <el-table-column
          label="类型">
          <template slot-scope="scope">
            {{ types[scope.row.types - 1].name }}
          </template>
        </el-table-column>

        <el-table-column
          label="加入时间">
          <template slot-scope="scope">
            {{ scope.row.et.substring(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-row>
        <el-col :span="2">
          <h6 style="text-align: left">团队成员</h6>
        </el-col>
        <el-col :span="2" :offset="20" v-if="this.$store.state.CurrentUser === 'super_admin'">
          <el-button size="mini" type="primary" style="margin-bottom: 5px" @click="toggleJoinTeam"><i class="el-icon-plus"></i></el-button>
        </el-col>
      </el-row>

      <el-row style="margin: 10px 0px; border: 1px solid #eee; border-radius: 5px; background-color: #eee" v-if="showJoinTeamForm">
        <el-form ref="form" label-width="90px" style="text-align: left">
          <el-form-item label="用户ID" style="margin-top: 15px">
            <el-row>
              <el-col :span="10">
                <el-input v-model="customerId" placeholder="用户id"></el-input>
              </el-col>
              <el-col :span="2" :offset="2">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要将当前客户加入到团队吗？"
                  @confirm="joinTeam">
                  <el-button slot="reference" type="danger"><i class="el-icon-plus"></i> 加入</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-row>

      <el-table
        :data="dataList"
        border
        style="width: 100%">
        <el-table-column
          prop="id"
          label="#">
        </el-table-column>

        <el-table-column
          prop="preBalance"
          label="用户编号">
          <template slot-scope="scope">
            <router-link :to="{path: '/user/details', query: {id: scope.row.customerId}}">{{scope.row.customerId}}</router-link>
          </template>
        </el-table-column>

        <el-table-column
          prop="createAt"
          sortable
          label="加入时间">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "TeamInfo",
  props: {
    providerId: String,
    dataList: Array,
    recommender: String,
    providerList: Array,
  },
  data() {
    return {
      showJoinTeamForm: false,
      customerId: '',
      types: [
        {type: 1, name: '省代'},
        {type: 2, name: '城市合伙人'},
        {type: 3, name: '汽车修理厂'},
        {type: 4, name: '备用'},
        {type: 5, name: '备用'},
        {type: 6, name: '市代'},
      ],
    }
  },

  methods: {
    joinTeam() {
      const params = {
        providerId: this.providerId,
        customerId: this.customerId,
      }

      api.joinTeam(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error.message)
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    },

    toggleJoinTeam() {
      this.showJoinTeamForm = !this.showJoinTeamForm
    },

    confirmUpdateRecommender() {
      const params = {
        providerId: this.providerId,
        recommender: this.recommender,
      }

      api.providerUpdateRecommender(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error.message)
        } else {
          this.$message.success('更新成功')
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/providers/team/TeamInfo.vue